import { useParams, Link, Navigate } from "react-router-dom";
import { ArrowLeft, ArrowRight } from "lucide-react";
import { articles } from "@/data/content";
import { Reveal, MaskedLines } from "@/components/site/Reveal";
import BookCTA from "@/components/site/BookCTA";

export default function Articulo() {
  const { slug } = useParams();
  const article = articles.find((a) => a.slug === slug && a.published);

  if (!article) return <Navigate to="/cuaderno" replace />;

  const others = articles.filter((a) => a.published && a.slug !== slug).slice(0, 2);

  return (
    <div data-testid="articulo-page">
      <header className="max-w-[900px] mx-auto px-5 md:px-10 pt-32 md:pt-44 pb-12 md:pb-16">
        <Link
          to="/cuaderno"
          className="inline-flex items-center gap-2 overline mb-8 hover:text-[#9C5A4B] transition-colors duration-300"
          data-testid="article-back"
        >
          <ArrowLeft size={14} /> Cuaderno
        </Link>
        <h1 className="font-display text-4xl sm:text-5xl md:text-6xl leading-[1.03] tracking-tight">
          <MaskedLines lines={[article.title]} />
        </h1>
      </header>

      <article className="max-w-[720px] mx-auto px-5 md:px-10 pb-24 md:pb-32">
        {article.content.map((p, i) => (
          <Reveal key={i} delay={i * 0.03}>
            <p
              className={`text-lg md:text-xl leading-relaxed text-[#1a1a1a]/85 font-light ${
                i === 0 ? "first-letter:font-display first-letter:text-6xl first-letter:float-left first-letter:mr-3 first-letter:mt-1 first-letter:text-[#9C5A4B]" : "mt-6"
              }`}
            >
              {p}
            </p>
          </Reveal>
        ))}
      </article>

      {/* Read next */}
      <section className="bg-[#efece5]">
        <div className="max-w-[1400px] mx-auto px-5 md:px-10 py-20 md:py-28">
          <p className="overline mb-10">Seguir leyendo</p>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            {others.map((a) => (
              <Link
                key={a.slug}
                to={`/cuaderno/${a.slug}`}
                data-testid={`article-next-${a.slug}`}
                className="group block border-t border-black/15 pt-6"
              >
                <h3 className="font-display text-2xl md:text-3xl tracking-tight leading-tight group-hover:text-[#9C5A4B] transition-colors duration-300">
                  {a.title}
                </h3>
                <span className="mt-4 inline-flex items-center gap-2 text-sm text-[#9C5A4B]">
                  Leer
                  <ArrowRight size={15} className="transition-transform duration-300 group-hover:translate-x-1" />
                </span>
              </Link>
            ))}
          </div>
        </div>
      </section>

      <BookCTA />
    </div>
  );
}
